export default __webpack_public_path__ + "static/media/error_record.d2be4bdd.svg";